import React from "react";

function SlaReportChildren({data}){
    return(
        data && data.map((code, index) => {
            return (
                <React.Fragment key={index}>
                    <tr>
                        {index === 0 && (
                            <>
                                <th className={"fieldset-th-sla"} rowSpan={data.length + 3}>유지보수 서비스</th>
                                <th className={"fieldset-th-sla"} rowSpan={data.length}>가동률</th>
                            </>
                        )}
                        <th className={"fieldset-th-sla"}>{code.section}</th>
                        <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{code.weight}%</td>
                        <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>월간</td>
                        <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{code.goal}%</td>
                        <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{code.min}%</td>
                        <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{code.checkResult}%</td>
                        <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{code.checkValue}%</td>
                        <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{code.customerCheckResult}%</td>
                        <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{code.customerCheckValue}%</td>
                        <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{code.etc}</td>
                    </tr>
                </React.Fragment>
            );
        })
    )
}

export {SlaReportChildren}